import { render } from "./editProfile.vue?vue&type=template&id=7c12e15f"
import script from "./editProfile.vue?vue&type=script&lang=js"
export * from "./editProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__